
















































































































import './scss/TheRegistration.scss';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { userNamespace } from '@store/modules/user';
import { UserActionTypes } from '@store/modules/user/Types';

const PASSWORD_HINT_CLOSED_KEY = 'registrationPasswordHintClosed';
const PASSWORD_MIN_LENGTH = 7;
const PASSWORD_REQUIREMENTS_ERROR = 'Пароль должен содержать не менее 7 символов, заглавную и строчную латинские буквы, цифру и специальный символ.';

@Component({
    name: 'Auth',

    components: {
        BaseInput: () => import('@components/BaseInputs/BaseInput.vue'),
    },
})
export default class TheRegistration extends Vue {
    @userNamespace.Action(UserActionTypes.A_COMPLETE_REGISTRATION) completeRegistration!: (payload) => Promise<void>;
    @userNamespace.Action(UserActionTypes.A_REGISTRATION_INFO) getRegistrationInfo!: (payload) => Promise<any>;

    fields = {
        name: '',
        email: '',
        password: '',
    }
    errors = {
        name: false,
        password: false,
    }
    realtimeValidation: boolean = false;
    accessId: string = '';
    canRegister: boolean = false;
    isNameReadonly: boolean = false;
    btnDisabled: boolean = false;
    showPasswordTooltip: boolean = false;
    passwordHintWasShown: boolean = false;
    passwordErrorText: string = '';

    mounted(): void {
        this.checkRegistrationInfo();
        this.passwordHintWasShown = sessionStorage.getItem(PASSWORD_HINT_CLOSED_KEY) === 'true';
    }

    get errorExists(): boolean {
        return Object.values(this.errors).some((item) => item);
    }

    get passwordHintTitle(): string {
        return `Пароль должен содержать не менее ${PASSWORD_MIN_LENGTH} символов, включая:`;
    }

    checkRegistrationInfo(): void {
        if (this.$route.query.id) {
            this.accessId = this.$route.query.id.toString();
            this.getRegistrationInfo({id: this.accessId}).then((data) => {
                if (data.canRegister) {
                    this.canRegister = data.canRegister;
                }
                if (data.email) {
                    this.fields.email = data.email;
                }
                const rawFullName = (data.fullName || data.full_name || data.name || '').trim();
                const looksLikeEmail = rawFullName.includes('@');

                if (rawFullName && !looksLikeEmail) {
                    this.fields.name = rawFullName;
                    this.isNameReadonly = true;
                } else {
                    this.fields.name = '';
                    this.isNameReadonly = false;
                }
            });
        }
    }

    validateFields(): void {
        this.errors.name = !this.fields.name;
        this.validatePassword();
    }

    validatePassword(): void {
        const hasMinLength = this.fields.password.length >= PASSWORD_MIN_LENGTH;
        const hasUppercaseLatin = /[A-Z]/.test(this.fields.password);
        const hasLowercaseLatin = /[a-z]/.test(this.fields.password);
        const hasNumber = /\d/.test(this.fields.password);
        const hasSpecialCharacter = /[^A-Za-z0-9]/.test(this.fields.password);
        this.errors.password = !hasMinLength || !hasUppercaseLatin || !hasLowercaseLatin || !hasNumber || !hasSpecialCharacter;
        this.passwordErrorText = this.errors.password ? PASSWORD_REQUIREMENTS_ERROR : '';
    }

    checkValidation(): void {
        if (this.realtimeValidation) {
            this.validateFields();
        }
    }

    checkSendForm(): void {
        this.realtimeValidation = true;
        if (this.canRegister) {
            this.sendForm();
        }
    }

    showPasswordHintOnFirstFocus(): void {
        if (this.passwordHintWasShown) {
            return;
        }
        this.showPasswordTooltip = true;
    }

    closePasswordTooltip(): void {
        this.showPasswordTooltip = false;
        this.passwordHintWasShown = true;
        sessionStorage.setItem(PASSWORD_HINT_CLOSED_KEY, 'true');
    }

    hidePasswordTooltip(): void {
        this.showPasswordTooltip = false;
    }

    sendForm(): void {
        this.validateFields();
        if (!this.errorExists) {
            this.btnDisabled = true;
            this.completeRegistration({
                id: this.accessId,
                fullName: this.fields.name,
                password: this.fields.password,
            }).then(() => {
                this.$router.push({ path: '/auth' });
            }).finally(() => {
                this.btnDisabled = false;
            })
        }
    }
}
